module.exports = {"dashboard.title":"Dashboard"}


//////////////////
// WEBPACK FOOTER
// ./lngProvider/locales/en_US.json
// module id = 961
// module chunks = 17